module.exports = __webpack_public_path__ + "img/icon-24-ic-minus.6d2fa591.svg";